import {SectionNomenklature, Width} from "../../../../../../store/types/store";
import {splitNameIntoRows} from "../../../../utils/splitNameIntoRows";
import {ISectionLabelRow} from "../../../../types";

export const getNomenclatureItems = (nomenklature: SectionNomenklature): Array<ISectionLabelRow> => {
    const nomenclatureItems: Array<ISectionLabelRow> = []
    const sizes: Width[] = [600, 800, 1200]
    const getNomenclatureLabel = (side: 'horizontal' | 'vertical', size: Width, count: number) => {
        let label = ''
        if (side === 'horizontal') {
            label += 'Горизонтальная'
        }
        if (side === 'vertical') {
            label += 'Вертикальная'
        }
        label += ` направляющая ${size}`
        return {remainedLabel: label, remainedCount: count, isBold: false, isRed: false}
    }
    sizes.forEach(size => {
        if (!!nomenklature.horizontal[size]) {
            nomenclatureItems.push(getNomenclatureLabel('horizontal', size, nomenklature.horizontal[size]))
        }
        if (!!nomenklature.vertical[size]) {
            nomenclatureItems.push(getNomenclatureLabel('vertical', size, nomenklature.vertical[size]))
        }
    })
    if (nomenklature.connector !== 0) {
        nomenclatureItems.push({
            remainedLabel: 'Соединитель',
            remainedCount: nomenklature.connector,
            isRedRemainedLabel: false
        })
    }
    if ((nomenklature.remainderRight !== undefined) && (nomenklature.remainderRight > 0)) {
        nomenclatureItems.push({
            remainedLabel: `Требуется отпил правой стойки на ${nomenklature.remainderRight} мм`,
            remainedCount: 0,
            isRedRemainedLabel: true
        })
    }
    if ((nomenklature.remainderLeft !== undefined) && (nomenklature.remainderLeft > 0)) {
        nomenclatureItems.push({
            remainedLabel: `Требуется отпил левой стойки на ${nomenklature.remainderLeft} мм`,
            remainedCount: 0,
            isRedRemainedLabel: true
        })
    }
    const nomenclatureItemsNames: Array<ISectionLabelRow> = []
    nomenclatureItems.forEach(nomenclature => {
        const names = splitNameIntoRows(nomenclature.remainedLabel || '', 220, nomenclature.isRedRemainedLabel ? 9 : 12)
        names.forEach((name, index, array) => {
            if (array.length - 1 === index) {
                nomenclatureItemsNames.push({
                    remainedLabel: name,
                    remainedCount: nomenclature.remainedCount,
                    isRedRemainedLabel: nomenclature.isRedRemainedLabel
                })
            } else {
                nomenclatureItemsNames.push({
                    remainedLabel: name,
                    remainedCount: 0,
                    isRedRemainedLabel: nomenclature.isRedRemainedLabel
                })
            }
        })
    })
    return nomenclatureItemsNames
}
